//GENERAL
export const GENERAL_CONSTANT = "_grandus-frontend-secure-session";

//SESSIONS
// - USER
export const USER_CONSTANT = "_grandus_user";
export const USER_COMPARE_CONSTANT = "_grandus_user_compare";
export const USER_WISHLIST_CONSTANT = "_grandus_user_wishlist";
// - CART
export const CART_CONSTANT = "_grandus_cart";
export const CART_CONTACT_CONSTANT = "_grandus_cart_contact";

// - LEGAL
export const LEGAL_COOKIE_CONSENT = "_grandus_cookie_consent";

// - STORAGE
export const SESSION_STORAGE_CONSTANT = "_grandus-frontend-session-storage";
export const DELIVERY_DATA_SESSION_STORAGE_KEY = "deliveryProviderData";

export const USER_LAST_SEEN_CONSTANT = '_grandus_user_lastSeen'
export const CURRENCY_COOKIE_NAME_CONSTANT = '_grandus_currency'
